module.exports = __webpack_public_path__ + "img/shrubnw.3fd9cae8.webp";